import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Probabilité";
const DESCRIPTION =
  "Calculatrice Probabilité pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "probabilité, calculatrice probabilité, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/probability";
function ProbabilityCalculator() {
  const [favorable, setFavorable] = useState("");
  const [total, setTotal] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const fav = parseFloat(favorable);
      const tot = parseFloat(total);
      if (isNaN(fav) || isNaN(tot) || tot === 0) {
        setError("Veuillez entrer des valeurs valides");
        setResult("");
        return;
      }
      const prob = (fav / tot).toFixed(4);
      const percent = ((fav / tot) * 100).toFixed(2);
      setResult({ probability: prob, percent });
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Résultats favorables:</label>
                    <input
                      type="number"
                      value={favorable}
                      onChange={(e) => setFavorable(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Résultats totaux:</label>
                    <input
                      type="number"
                      value={total}
                      onChange={(e) => setTotal(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <div>
                    <p className="p-3 mb-2 bg-success text-white">
                      Probabilité: {result.probability}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Pourcentage: {result.percent}%
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de probabilités — succès et échecs</h3>
                    </div>
                    <div className="info-section-body">
                      <div>
                        <p>
                          La calculatrice de probabilités est un outil mathématique gratuit
                          qui vous aide à calculer le pourcentage de succès et d'échecs
                          pour un événement à deux issues possibles. Elle est utilisée
                          en statistiques, en mathématiques, en recherche scientifique
                          et en analyse de données.
                        </p>
                        <p>
                          Elle fonctionne dans les deux sens : vous pouvez saisir des nombres
                          pour obtenir des pourcentages, ou saisir des pourcentages pour
                          obtenir des nombres.
                        </p>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Méthodes de calcul disponibles :</strong></p>
                        <ol>
                          <li><strong>Des nombres aux pourcentages :</strong> entrez le nombre de succès et d'échecs, la calculatrice en déduira les pourcentages.</li>
                          <li><strong>Du nombre de succès et du taux d'échec :</strong> entrez le nombre de succès et le pourcentage d'échecs.</li>
                          <li><strong>Du nombre de succès et du taux de succès :</strong> entrez le nombre de succès et le pourcentage de succès.</li>
                          <li><strong>Du nombre d'échecs et des pourcentages :</strong> entrez le nombre d'échecs et un pourcentage.</li>
                        </ol>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Formules de calcul :</strong></p>
                        <p>Probabilité de succès = (nombre de succès ÷ total) × 100%</p>
                        <p>Probabilité d'échec = (nombre d'échecs ÷ total) × 100%</p>
                        <p>Probabilité de succès + probabilité d'échec = 100%</p>
                        <p>
                          <strong>Exemple :</strong> 60 succès et 40 échecs →
                          Total = 100, succès = 60%, échecs = 40%.
                        </p>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Utilisations :</strong></p>
                        <ul>
                          <li>Taux de réussite aux examens</li>
                          <li>Analyse de résultats d'expériences scientifiques</li>
                          <li>Taux de conversion en marketing et ventes</li>
                          <li>Évaluation de la qualité en fabrication</li>
                          <li>Analyse statistique dans la recherche</li>
                          <li>Évaluation des risques dans les projets et investissements</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default ProbabilityCalculator;
